var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('p',[_vm._v(" "+_vm._s(_vm.ActivityData.CommentText.Value))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',{staticClass:"row-element"},[_vm._v("Commented on an AHJ, saying:")])])
}]

export { render, staticRenderFns }